module.exports = __webpack_public_path__ + "img/sup_deposit_bank_4.e9a9208f.png";